import { Locale } from '@/types/language.type';

type SlugMap = {
  id: string;
  slugs: {
    en: string;
    hr: string;
  };
};

export const blogPostsSlugMap: SlugMap[] = [
  {
    id: 'axios-complete-guide',
    slugs: {
      en: 'axios-complete-guide',
      hr: 'axios-kompletni-vodic',
    },
  },
  {
    id: 'react-hook-form-complete-guide',
    slugs: {
      en: 'react-hook-form-complete-guide',
      hr: 'react-hook-form-kompletni-vodic',
    },
  },
  {
    id: 'how-to-add-material-ui-to-your-projects',
    slugs: {
      en: 'how-to-add-material-ui-to-your-projects',
      hr: 'kako-dodati-material-ui-u-projekt',
    },
  },
  {
    id: 'how-to-add-translations-to-next-projects',
    slugs: {
      en: 'how-to-add-translations-to-next-projects',
      hr: 'kako-dodati-prijevode-u-nextjs-projekt',
    },
  },
  {
    id: 'how-to-add-translations-to-react-projects',
    slugs: {
      en: 'how-to-add-translations-to-react-projects',
      hr: 'kako-dodati-prijevode-u-react-projekt',
    },
  },
  {
    id: 'how-to-set-up-eslint-and-prettier-in-react-and-nextjs-projects',
    slugs: {
      en: 'how-to-set-up-eslint-and-prettier-in-react-and-nextjs-projects',
      hr: 'kako-postaviti-eslint-i-prettier-u-react-i-nextjs',
    },
  },
  {
    id: 'how-to-use-markdown-to-make-static-pages-and-blog-posts',
    slugs: {
      en: 'how-to-use-markdown-to-make-static-pages-and-blog-posts',
      hr: 'kako-koristiti-markdown-za-staticke-stranice-i-blogove',
    },
  },
  {
    id: 'simplifying-state-management-in-react-with-valtio',
    slugs: {
      en: 'simplifying-state-management-in-react-with-valtio',
      hr: 'upravljanje-stanjem-u-reactu-s-valtiom',
    },
  },
  {
    id: 'when-to-use-type-and-when-to-use-interface',
    slugs: {
      en: 'when-to-use-type-and-when-to-use-interface',
      hr: 'kada-koristiti-type-a-kada-interface',
    },
  },
  {
    id: 'cookie-consent-data-management-and-compliance',
    slugs: {
      en: 'cookie-consent-data-management-and-compliance',
      hr: 'pristanak-na-kolacice-upravljanje-podacima',
    },
  },
  {
    id: 'workspace-top-100-software-development-companies-techreviewer',
    slugs: {
      en: 'workspace-top-100-software-development-companies-techreviewer',
      hr: 'workspace-top-100-tvrtki-za-razvoj-softvera-techreviewer',
    },
  },
  {
    id: 'tailwind-css-crisis-2026-what-developers-need-to-know',
    slugs: {
      en: 'tailwind-css-crisis-2026-what-developers-need-to-know',
      hr: 'kriza-tailwind-css-2026-sto-trebate-znati-kao-developer',
    },
  },
  {
    id: 'how-to-integrate-cursor-into-your-ai-development-workflow',
    slugs: {
      en: 'how-to-integrate-cursor-into-your-ai-development-workflow',
      hr: 'kako-integrirati-cursor-u-vas-ai-razvojni-proces',
    },
  },
  {
    id: 'our-5-favorite-figma-plugins',
    slugs: {
      en: 'our-5-favorite-figma-plugins',
      hr: 'nasih-5-najdrazih-figma-plugina',
    },
  },
  {
    id: 'setting-up-gsap-in-nextjs',
    slugs: {
      en: 'setting-up-gsap-in-nextjs',
      hr: 'postavljanje-gsap-a-u-nextjs-u',
    },
  },
  {
    id: 'ai-driven-digital-transformation',
    slugs: {
      en: 'ai-driven-digital-transformation',
      hr: 'digitalna-transformacija-uz-pomoc-ai',
    },
  },

  {
    id: 'ai-driven-prototyping-from-idea-to-working-product-in-days',
    slugs: {
      en: 'ai-driven-prototyping-from-idea-to-working-product-in-days',
      hr: 'ai-driven-prototyping-od-ideje-do-proizvoda-u-nekoliko-dana',
    },
  },
  {
    id: 'how-claude-skills-turn-team-expertise-into-reusable-ai-workflows',
    slugs: {
      en: 'how-claude-skills-turn-team-expertise-into-reusable-ai-workflows',
      hr: 'kako-claude-skills-pretvaraju-timsko-znanje-u-ponovljive-ai-radne-procese',
    },
  },

  {
    id: 'ai-strategy-small-business',
    slugs: {
      en: 'ai-strategy-small-business',
      hr: 'ai-strategija-za-malo-poduzetnistvo',
    },
  },
  {
    id: 'ai-figma-integration-gaps',
    slugs: {
      en: 'ai-figma-integration-gaps',
      hr: 'ai-alati-za-dizajn-jos-nisu-na-zeljenoj-razini',
    },
  },
  {
    id: 'wordpress-migration-shared-hosting-vps',
    slugs: {
      en: 'wordpress-migration-shared-hosting-vps',
      hr: 'wordpress-migracija-shared-hosting-vps',
    },
  },
  {
    id: 'how-pretext-works',
    slugs: {
      en: 'how-pretext-works',
      hr: 'kako-pretext-funkcionira',
    },
  },
  {
    id: 'once-again-designers-are-dead',
    slugs: {
      en: 'once-again-designers-are-dead',
      hr: 'jos-jednom-dizajneri-su-mrtvi',
    },
  },
  {
    id: 'whats-going-on-at-github',
    slugs: {
      en: 'whats-going-on-at-github',
      hr: 'sto-se-dogada-githubu',
    },
  },
  {
    id: 'vibe-coding-prototype-to-production',
    slugs: {
      en: 'vibe-coding-prototype-to-production',
      hr: 'vibe-coding-od-prototipa-do-produkcije',
    },
  },
  {
    id: 'what-a-secure-wordpress-site-looks-like',
    slugs: {
      en: 'what-a-secure-wordpress-site-looks-like',
      hr: 'kako-izgleda-sigurna-wordpress-stranica',
    },
  },
  {
    id: 'ai-search-visibility',
    slugs: {
      en: 'ai-search-visibility',
      hr: 'zasto-vas-ai-trazilice-ne-pronalaze',
    },
  },
  {
    id: 'how-to-build-a-proper-design-system',
    slugs: {
      en: 'how-to-build-a-proper-design-system',
      hr: 'kako-izgraditi-dobar-dizajn-sistem',
    },
  },
  {
    id: 'npm-supply-chain-attacks-2026',
    slugs: {
      en: 'npm-supply-chain-attacks-2026',
      hr: 'napadi-na-npm-pakete-2026',
    },
  },
  {
    id: 'google-new-ai-powered-search',
    slugs: {
      en: 'google-new-ai-powered-search',
      hr: 'google-novi-ai-agenti-za-pretragu',
    },
  },
  {
    id: 'why-open-weight-models-have-openai-worried',
    slugs: {
      en: 'why-open-weight-models-have-openai-worried',
      hr: 'zasto-otvoreni-modeli-zabrinjavaju-openai',
    },
  },
  {
    id: 'prepare-webshop-google-ai-mode-shopping',
    slugs: {
      en: 'prepare-webshop-google-ai-mode-shopping',
      hr: 'kako-pripremiti-webshop-za-google-ai-mode',
    },
  },
  {
    id: 'wix-collapse-2026-ai-website-builders',
    slugs: {
      en: 'wix-collapse-2026-ai-website-builders',
      hr: 'kolaps-wixa-2026-i-ai-alati-za-izradu-web-stranica',
    },
  },
  {
    id: 'eu-ai-act-transparency-obligations',
    slugs: {
      en: 'eu-ai-act-transparency-obligations',
      hr: 'obveze-transparentnosti-eu-akta-o-umjetnoj-inteligenciji',
    },
  },
  {
    id: 'innovate-split-2026-workspace',
    slugs: {
      en: 'innovate-split-2026-workspace',
      hr: 'innovate-split-2026-osvrt-workspace',
    },
  },
  {
    id: 'infobip-shift-2026-recap-exhibiting-in-zadar',
    slugs: {
      en: 'infobip-shift-2026-recap-exhibiting-in-zadar',
      hr: 'infobip-shift-2026-dojmovi-izlagaca-iz-zadra',
    },
  },
  {
    id: 'llm-wiki-second-brain-ai-os',
    slugs: {
      en: 'llm-wiki-second-brain-ai-os',
      hr: 'llm-wiki-second-brain-ai-os-vodic-za-tvrtke',
    },
  },
  {
    id: 'forward-deployed-engineer-croatia',
    slugs: {
      en: 'forward-deployed-engineer-croatia',
      hr: 'forward-deployed-engineer-hrvatska',
    },
  },
  {
    id: 'from-sole-proprietorship-to-company',
    slugs: {
      en: 'from-sole-proprietorship-to-company',
      hr: 'od-obrta-do-tvrtke',
    },
  },
  {
    id: 'what-is-agent-experience-ax',
    slugs: {
      en: 'what-is-agent-experience-ax',
      hr: 'sto-je-iskustvo-ai-agenata-ax',
    },
  },
  {
    id: 'ai-audit-for-small-business',
    slugs: {
      en: 'ai-audit-for-small-business',
      hr: 'ai-pregled-za-malu-tvrtku',
    },
  },
];

export const getTranslatedSlug = (
  slugMap: SlugMap[],
  slug: string,
  targetLocale: Locale,
  currentLocale: Locale
): string => {
  if (targetLocale === currentLocale) {
    return slug;
  }

  const entry = slugMap.find(item => item.slugs[currentLocale] === slug);

  if (entry) {
    return entry.slugs[targetLocale];
  }

  return slug;
};

export const getTranslatedBlogSlug = (slug: string, targetLocale: Locale, currentLocale: Locale): string =>
  getTranslatedSlug(blogPostsSlugMap, slug, targetLocale, currentLocale);
